/**
 @ngdoc directive
 @name timesheetSummary

 @description
 Timesheet widget that displays summary for hourly and daily timesheets in timesheet search tiles.

 */

(function() {
    'use strict';

    var timesheetSummary = function($templateCache, i18nService) {
        return {
            restrict: "E",
            scope: true,
            bindToController: {
                data: '=',
                startDate: '=',
                endDate: '=',
                type: '='
            },
            controllerAs: 'ctrl',
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
                var _this = this;

                this.$onInit = function () {

                    _this.i18nService = i18nService.preLoadI18nValues({
                        'default.total.label': 'Total',
                        'default.abbreviation.day.label': 'd',
                        'default.abbreviation.hour.label': 'h',
                        'default.abbreviation.min.label': 'm',
                    });

                    // Defining new timesheet data structure
                    _this.timesheetData = {
                        days: []
                    };

                    /**
                     * Calling function to generate new timesheet data
                     */
                    getTimesheetData(_this.startDate, _this.endDate, _this.data, _this.type);

                    /**
                     * Generating new timesheet data
                     * @param startDate
                     * @param endDate
                     * @param data
                     * @param type
                     */
                    function getTimesheetData(startDate, endDate, data, type){
                        for (var d = new Date(startDate); d <= new Date(endDate);d.setDate(d.getDate() + 1)) {
                            var dayOfWeekDate =  new Date(d);

                            // Pushing value object towards generated date with matching date in raw data
                            _this.timesheetData.days.push({date: dayOfWeekDate, value: getTimeData(data, dayOfWeekDate, type)});
                        }
                        // Declaring timesheet type
                        _this.timesheetData.type = type;
                    }

                    /**
                     * Creating object with value data for hourly or daily timesheet
                     * @param data
                     * @param generatedDate
                     * @param type
                     * @returns {*}
                     */
                    function getTimeData(data, generatedDate, type){
                        var timeDataValue = 0;
                        // Looping through data passed
                        data.forEach(function(singleData){
                            // Checking if data passed matches any of the generated dates
                            if(new Date(singleData.date).getDate() == generatedDate.getDate()){
                                if(type == "daily"){
                                    timeDataValue = timeDataValue + singleData.duration;
                                }else{
                                    timeDataValue = timeDataValue + getMinutes(singleData.hours, singleData.minutes);
                                }
                            }
                        });
                        // Returning value object
                        if(type == "daily"){
                            return {days: timeDataValue};
                        }else{
                            return {minutes: timeDataValue};
                        }
                    }

                    /**
                     * Template unction that returns minutes from raw data
                     * @param hours
                     * @param minutes
                     * @returns {*|number}
                     */
                    function getMinutes(hours, minutes){
                        var newMinutes = 0;
                        if(hours){
                            newMinutes = (hours * 60) + minutes;
                        }else{
                            newMinutes = minutes;
                        }
                        return newMinutes;
                    }

                    /**
                     * Template function that counts total days
                     * @returns {*}
                     */
                    $scope.getTotalDays = function(){
                        var totalDays = 0;
                        _this.data.forEach(function(timesheet){
                            if(_this.type == 'daily'){
                                totalDays = totalDays + timesheet.duration;
                            }
                        });
                        return totalDays;
                    };

                    /**
                     * Template function that counts total hours and minutes
                     * @returns {string}
                     */
                    $scope.getTotalMinutes = function(){
                        var totalMinutes = 0;
                        _this.data.forEach(function(timesheet){
                            if(_this.type == 'hourly'){
                                totalMinutes = totalMinutes + (timesheet.hours * 60) + timesheet.minutes;
                            }
                        });
                        return totalMinutes;
                    };

                    /**
                     * Template function that returns hours
                     * @param minutes
                     * @returns {number}
                     */
                    $scope.getHours = function(minutes){
                        return Math.floor(minutes / 60);
                    };

                    /**
                     * Template function that returns spare minutes
                     * @param minutes
                     * @returns {number}
                     */
                    $scope.getSpareMinutes = function(minutes){
                        var hours = Math.floor(minutes / 60);
                        return minutes - (hours * 60);
                    };

                }

            }],
            template: $templateCache.get('components/listing/timesheetSummary.html')
        };
    };
    timesheetSummary.$inject = ['$templateCache', 'i18nService'];
    angular.module('app').directive('timesheetSummary', timesheetSummary);

}());